export const LIST_EARNINGS = '[Earnings] List earnings';
export const LIST_EARNINGS_SUCCESS = '[Earnings] List earnings Success';
export const LIST_EARNINGS_ERROR = '[Earnings] List earnings Error';

export const GET_TOTAL_EARNINGS = '[Earnings] Get total earnings';
export const GET_TOTAL_EARNINGS_SUCCESS =
  '[Earnings] Get total earnings Success';
export const GET_TOTAL_EARNINGS_ERROR = '[Earnings] Get total earnings Error';

export const LIST_DEACTIVATED_ARTIST_EARNINGS =
  '[Earnings] List deactivated artist earnings';
export const LIST_DEACTIVATED_ARTIST_EARNINGS_SUCCESS =
  '[Earnings] List deactivated artist earnings Success';
export const LIST_DEACTIVATED_ARTIST_EARNINGS_ERROR =
  '[Earnings] List deactivated artist earnings Error';

export const GET_EARNINGS_EXPORT_URL = '[Earnings] Get earnings export url';
export const GET_EARNINGS_EXPORT_URL_SUCCESS =
  '[Earnings] Get earnings export url Success';
export const GET_EARNINGS_EXPORT_URL_ERROR =
  '[Earnings] Get earnings export url Error';

export const GENERATE_EXPORT_URL = '[Earnings] Generate export url';
export const GENERATE_EXPORT_URL_SUCCESS =
  '[Earnings] Generate export url Success';
export const GENERATE_EXPORT_URL_ERROR = '[Earnings] Generate export url Error';
